var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_vm._v("客室数")]),_c('dd',[_c('p',{staticClass:"hotelNumberItem"},[_c('select',{domProps:{"value":_vm.numOfRooms},on:{"change":_vm.changeRoomNumber}},_vm._l((_vm.maxRoomCount),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(" "+_vm._s(i)+"室 ")])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }